import React from 'react';
import PropTypes from 'prop-types';
import randomstring from 'uuid/v4';

import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';

import AttachFile from '@material-ui/icons/AttachFile';
import CloseIcon from '@material-ui/icons/Close';
import Send from '@material-ui/icons/Send';

import FileUpload from './FileUpload';
import ProtectedImg from './ProtectedImg';
import Editor from './Editor';

const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <span className={"button-link barlowsemicondensed_bold c_slate padding_bottom_12 margin_bottom_12"}>
                {children}
            </span>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        minWidth: 320,
        minHeight: 400
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
}))(MuiDialogActions);

class DetailMessage extends React.Component {

    state = {
        adjuntos: [],
        descripcion: ''
    }

    handleChange = (event) => {
        console.log(event.target.value);
        this.setState({ [event.target.name]: event.target.value })
    }

    getFiles = (arr) => {
        const { adjuntos } = this.state;
        this.setState({ adjuntos: adjuntos.concat(arr) });
    }

    render() {
        const { descripcion, adjuntos } = this.state;
        const { intl, onClose, fullScreen, id } = this.props;

        return (
            <Dialog id="dialog"
                onClose={onClose(false)}
                aria-labelledby="customized-dialog-title"
                open={true}
                className="z_index_dialog"
                fullScreen={fullScreen}>
                <DialogTitle id="customized-dialog-title" onClose={onClose(false)}>
                    {intl.formatMessage({ id: 'communication_answer' })}
                </DialogTitle>
                <DialogContent dividers>
                    <div className="flex_full_column">
                        <Editor
                            {...this.props}
                            id={randomstring()}
                            name="descripcion"
                            value={descripcion}
                            onChange={this.handleChange}
                        />
                        <div className="flex_auto_column margin_top_8">
                            <div className="flex_auto_row align_center">
                                <AttachFile className="c_disabled margin_right_2 communications_icon" />
                                <p className="flex_full_row barlow_regular_small c_slate">{intl.formatMessage({ id: 'attach' })}</p>
                            </div>
                            <div className="flex_auto_row align_center">
                                <FileUpload
                                    {...this.props}
                                    multiple
                                    communication={false}
                                    onDone={this.getFiles.bind(this)}
                                    instance={this.props.instance}
                                    id={id}
                                />
                                {adjuntos.length > 0 &&
                                    adjuntos.map((a, index) => {
                                        return (
                                            <ProtectedImg
                                                {...this.props}
                                                key={`thumbnail-${id}-${a.id}`}
                                                edit
                                                communication={false}
                                                id={a.id}
                                                parent={id}
                                                name={a.nombre}
                                                src={`${process.env.REACT_APP_API_MESSAGES}/${id}/adjunto/${a.id}/miniatura?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                                download={`${process.env.REACT_APP_API_MESSAGES}/${id}/adjunto/${a.id}/datos/${a.nombre}?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                            />)
                                    })
                                }
                            </div>
                        </div>
                    </div>

                </DialogContent>
                <DialogActions>
                    <div className={"button-send align_center flex_auto_row margin_top_12 " + ((descripcion !== '<p><br></p>' && descripcion !== '<p></p>' && descripcion !== '') ? '' : 'disabled')} onClick={onClose(true, descripcion)}>
                        <Send className="c_bluish margin_right_6" />
                        {intl.formatMessage({ id: 'communication_send' })}
                    </div>
                </DialogActions>
            </Dialog>
        );
    }
}

DetailMessage.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(DetailMessage);


// WEBPACK FOOTER //
// ./src/components/complex/communications/PopupAnswer.js